export enum SeenStatusEnum {
  SEEN = 'seen',
  UNSEEN = 'unseen',
}
